import getApi from '../../api/apisauceConfig'
import { deserializeQuestionnaireInstanceScoreResponse } from './mapper/questionnaireInstanceScore.mapper'

export const getQuestionnaireInstanceScore = (documentId: number, questionnaireId: number) =>
  getApi()
    .get<{
      value: number
    }>(`/documents/${documentId}/questionnaire_instance/${questionnaireId}/computed_value`)
    .then(deserializeQuestionnaireInstanceScoreResponse)
